import banner.BannerManager
import common.dto.Vec3d
import editor.EditorManager
import kotlinx.browser.document
import scroll.ScrollManger
import scroll.mainScrollAnimation
import viewer.ViewerManager

enum class Page(val path: String) {
    /**
     * Home page with an overview of the capabilities of the brixi etc.
     *
     * User can scroll through and objects are animated depending on the scroll progress.
     */
    HOME("/") {
        override suspend fun init() {
            ScrollManger
        }
        override fun render(dt: Double) = ScrollManger.render(mainScrollAnimation)
    },
    EDITOR("/editor") {
        override suspend fun init() = EditorManager.init()
        override fun render(dt: Double) = EditorManager.render()
        override val initialCameraPosition = Vec3d(x = 100.0, y = 140.0, z = 140.0)
    },
    VIEWER("/viewer") {
        override suspend fun init() = ViewerManager.init()
        override fun render(dt: Double) = ViewerManager.render()
        override val initialCameraPosition = Vec3d(x = 440.0, y = 600.0, z = 600.0)
    },
    BANNER("/banner") {
        override suspend fun init() = BannerManager.init()
        override fun render(dt: Double) = BannerManager.render(dt)
        override val initialCameraPosition = Vec3d(x = 0.0, y = 550.0, z = 550.0)
    },
    INSPIRATIONS("/inspirations");

    open val initialCameraPosition = Vec3d(z = 120.0)

    /**
     * Function that gets called once at the beginning to set up stuff.
     */
    open suspend fun init() {}

    /**
     * Function that gets called every frame to render stuff.
     */
    open fun render(dt: Double) {}
}

/**
 * The same script is used for multiple paths, e.g. / and /editor. Thus, on load we determine the page based on the
 * current path. We directly call the [Page.init] and [Page.render] methods. Additionally, the [currentPage] value
 * is checked e.g. to set the initial camera position.
 */
val currentPage = Page.entries.firstOrNull {
    it.path == document.location?.pathname || it.path == document.location?.pathname?.removeSuffix("/")
} ?: throw RuntimeException(
    "Page not found for path '${document.location?.pathname}'"
)